// extracted by mini-css-extract-plugin
export default {"container":"componentLoader_container__f3tWp"};